import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { showModal } from "react-redux-modal-provider";
import {
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  Typography,
  Skeleton,
  useTheme,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import {
  ButtonBasic,
  CardCuentaProducto,
  CardOTZTask,
  TextInfoTicket,
} from "../../components";
import TratoService from "../../services/tratos.service";
import ZTaskService from "../../services/ztask.service";
import TabCuentaTicket from "../contacto/tabs/TabCuentaTicket";
import MikrotikV2Service from "../../services/mikrotikV2.service";
import CalendarioV2Service from "../../services/calendarioV2.service";
import TabCuentaTareas from "../contacto/tabs/TabCuentaTareas";
import TabCuentaConsultas from "../contacto/tabs/TabCuentaConsultas";
import ConsultasService from "../../services/consultas.service";
import ApiSoftland from "../../services/apis.softland.service";
import ConfirmationDialog from "../../modals/default/ConfirmationDialog";
import TabCuentaHistorico from "../contacto/tabs/TabCuentaHistorico";
import LogService from "../../services/log.service";
import FechaFunction from "../../function/FechaFunction";
import AuxiliarFunction from "../../function/AuxiliarFunction";
import ReportesService from "../../services/reportes.service";
import TabCuentaRecodatorios from "../contacto/tabs/TabCuentaRecodatorios";
import RecordatorioService from "../../services/recordatorio.service";
import { SocketContext } from "../../context/SocketContext";
import ModalSaldoPendiente from "../../modals/servicio/ModalSaldoPendiente";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import usePermisos from "../../hooks/usePermisos";
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ServicioCuentaVerScreen = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const permisos = usePermisos();
  const { id } = useParams();
  const { sockets } = useContext(SocketContext);
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [isLoading, setIsLoading] = useState(true);
  const [infoCliente, setInfoCliente] = useState(null);
  const [trato, setTrato] = useState();
  const [items, setItems] = useState();
  const [extensiones, setExtensiones] = useState();
  const [tickets, setTickes] = useState([]);
  const [equipo, setEquipo] = useState(null);
  const [tareas, setTareas] = useState([]);
  const [consultas, setConsultas] = useState([]);
  const [localBd, setLocalBd] = useState(null);
  const [logs, setLogs] = useState([]);
  const [recordatorios, setRecordatorios] = useState([]);
  const [otsServicio, setOtsServicio] = useState([]);

  const groupBy = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
      const keyGB = obj[property];
      if (!acc[keyGB]) {
        acc[keyGB] = [];
      }
      acc[keyGB].push(obj);
      return acc;
    }, {});
  };
  const actualizar = async () => {
    setIsLoading(true);
    await TratoService.getByIdCuenta(id)
      .then((r) => {
        if(r?.localBd && r?.localBd?.id_t){
          if(!r?.localBd?.cuentaContratoId_t){
            navigate("/");
          }
        }
        setTrato(r);
        setItems([]);
        setExtensiones([]);
        setTickes([]);
        setEquipo(null);
        setTareas([]);
        setConsultas([]);
        setLocalBd(null);
      })
      .catch((e) => {
        if (e?.response?.data?.msg) {
          navigate("/");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const traerInfoMikrotik = async () => {
    await MikrotikV2Service.obtenerServicioId({ id: id }).then((resp) => {
      setEquipo(resp);
    });
  };
  const actualizarTareas = async () => {
    await CalendarioV2Service.tareasCalendar({ cuentaContratoId: id }).then(
      (resp) => {
        setTareas(resp);
      },
    );
  };
  const actualizarHistorico = async () => {
    await LogService.getAllContacto({ servicio: id }).then((resp) => {
      setLogs(resp);
    });
  };
  const onGuardar = () => {
    actualizar();
    actualizarTareas();
    traerInfoMikrotik();
    actualizarHistorico();
    actualizarRecordatorios();
    actualizarOTs();
  };
  const onNuevaCobertura = async () => {
    if (
      (trato?.latitud && trato?.longitud) ||
      (items?.length > 0 && items[0]?.descripcion)
    ) {
      const form = {
        contactoCuenta_con: trato?.cuenta,
        nombreContacto_con: trato?.cliente,
        direccionConsulta_con: trato?.direccion_servicio,
        coordenadasConsulta_con: `${trato?.latitud}, ${trato?.longitud}`,
        nroServicio: id,
      };
      if (items?.length > 0 && items[0]?.descripcion) {
        form.contactoCuenta_con = items[0]?.cuenta;
        form.nombreContacto_con = items[0]?.descripcion;
        form.direccionConsulta_con = items[0]?.ubicacion?.domicilio || "S/D";
        form.coordenadasConsulta_con = `${items[0]?.ubicacion?.latitud}, ${items[0]?.ubicacion?.longitud}`;
      }
      await ConsultasService.registerConsultaCobertura(form)
        .then(() => {
          setIsLoading(true);
          toast.success("Se realizó la consulta de cobertura correctamente.", {
            position: "top-right",
            autoClose: 3500,
            pauseOnHover: false,
          });
          onGuardar();
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };
  const onOpenModalAltaBajaDirEntrega = async (idDirEnt) => {
    showModal(ConfirmationDialog, {
      title: `${trato?.estado_direntrega ? "Activar" : "Eliminar"} la direccion de entrega`,
      message: `¿Esta seguro que desea dar de ${trato?.estado_direntrega ? "alta" : "baja"} la direccion de entrega?`,
      onConfirm: async () => {
        await ApiSoftland.altaBajaDireccionEntrega({ idDirEnt: idDirEnt }).then(
          async () => {
            await actualizar();
          },
        );
      },
    });
  };
  const onConsultarSaldo = () => {
    showModal(ModalSaldoPendiente, {
      servicios: [infoCliente?.numero || trato?.contrato || id],
    });
  };
  const onReporteServicioId = async () => {
    await AuxiliarFunction.downloadFile(
      ReportesService.reporteServicioId(id),
      id,
    );
  };
  useEffect(() => {
    const room = `servicio-${id}`;
    sockets?.emit("joinTicketRoom", room);
    actualizar().then(() => {
      actualizarTareas();
      traerInfoMikrotik();
      actualizarHistorico();
      actualizarRecordatorios();
      actualizarOTs();
    });
    document.title = `Servicio #${id}`;

    const onServicioRefresh = () => {
      actualizar().then(() => {
        actualizarTareas();
        traerInfoMikrotik();
        actualizarHistorico();
        actualizarRecordatorios();
        actualizarOTs();
      });
    };
    sockets?.on("servicioRefresh", onServicioRefresh);

    return () => {
      sockets?.off("servicioRefresh", onServicioRefresh);
      sockets?.emit("leaveTicketRoom", room);
    };
  }, [id]);
  useEffect(() => {
    if (trato && trato[id] && trato[id]?.length > 0) {
      setInfoCliente({
        nombre: trato[id][0]?.descripcion,
        numero: trato[id][0]?.numero,
        cuenta: trato[id][0]?.cuenta,
        vip: trato[id][0]?.vip,
      });
      setItems(trato[id]);
      trato[id].map((tk) => {
        if (tk.ticket) setTickes(tk.ticket);
        return "";
      });
    } else {
      setInfoCliente({
        nombre: trato?.cliente,
        numero: trato?.contrato,
        cuenta: trato?.cuenta,
        vip: trato?.vip,
      });
      setTickes(trato?.ticket || []);
    }
    setConsultas(trato?.consultas || []);
    setLocalBd(trato?.localBd || null);
  }, [trato]);

  useEffect(() => {
    if (items?.length > 0) {
      const filtro = items.filter((it) => !it?.ticket);
      const cantidad = groupBy(filtro, "extension");
      if (Object.keys(cantidad).length > 0) {
        setExtensiones(cantidad);
      }
    } else {
      setExtensiones([]);
    }
  }, [items]);

  const actualizarRecordatorios = async () => {
    await RecordatorioService.getAll({ servicioId: id }).then((resp) => {
      setRecordatorios(resp);
    });
  };
  const actualizarOTs = async () => {
    await ZTaskService.getOTServicio({ servicioId: id, all: true })
      .then((resp) => {
        setOtsServicio(resp?.ots || resp?.data?.ots || []);
      })
      .catch(() => {
        setOtsServicio([]);
      });
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          background: isDarkMode ? "#1a2332" : "#f5f5f5",
        }}
        className="side"
      >
        <Grid container p={3} mb={5} spacing={1}>
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                background: isDarkMode ? "#2d3a52" : "#fff !important",
                border: isDarkMode ? "1px solid #3d4a62" : "1px solid #e0e0e0",
                p: 2,
                borderRadius: 4,
                boxShadow: isDarkMode
                  ? "0px -3px 0px 0px #90caf9"
                  : "0px -3px 0px 0px #15294b",
              }}
            >
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                sx={{ mb: 2, bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 2,
                  flexDirection: "column",
                }}
              >
                <Skeleton
                  variant="circular"
                  width={80}
                  height={80}
                  sx={{ bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
                />
                <Skeleton
                  variant="text"
                  width="80%"
                  height={40}
                  sx={{ mt: 1, bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
                />
              </Box>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={45}
                sx={{
                  borderRadius: 2,
                  mb: 2,
                  bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0",
                }}
              />
              <Divider
                sx={{ mb: 2, background: isDarkMode ? "#3d4a62" : "#e0e0e0" }}
              />
              <Skeleton
                variant="text"
                width="100%"
                height={30}
                sx={{ bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
              />
              <Skeleton
                variant="text"
                width="100%"
                height={30}
                sx={{ bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
              />
              <Skeleton
                variant="text"
                width="100%"
                height={30}
                sx={{ bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
              />
              <Skeleton
                variant="text"
                width="100%"
                height={30}
                sx={{ bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
              />
            </Card>
          </Grid>
          <Grid item xs={12} md={9}>
            <Card
              sx={{
                background: isDarkMode ? "#2d3a52" : "#fff !important",
                border: isDarkMode ? "1px solid #3d4a62" : "1px solid #e0e0e0",
                p: 2,
                borderRadius: 4,
              }}
            >
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: isDarkMode ? "#3d4a62" : "#e0e0e0",
                  mb: 2,
                }}
              >
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={48}
                  sx={{ bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
                />
              </Box>
              <Box sx={{ p: 3 }}>
                <Skeleton
                  variant="text"
                  width="60%"
                  height={40}
                  sx={{ mb: 2, bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0" }}
                />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{
                    borderRadius: 2,
                    mb: 2,
                    bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{
                    borderRadius: 2,
                    bgcolor: isDarkMode ? "#1F2A40" : "#e0e0e0",
                  }}
                />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: isDarkMode ? "#1a2332" : "#f5f5f5",
      }}
      className="side"
    >
      <Grid container p={3} mb={5} spacing={1}>
        <Grid item xs={12} md={3}>
          <Card
            sx={{
              background: isDarkMode ? "#2d3a52" : "#fff !important",
              border: isDarkMode ? "1px solid #3d4a62" : "1px solid #e0e0e0",
              p: 2,
              borderRadius: 4,
              boxShadow: isDarkMode
                ? "0px -3px 0px 0px #90caf9"
                : "0px -3px 0px 0px #15294b",
            }}
          >
            <IconButton
              sx={{
                boxShadow: 3,
                background: isDarkMode ? "#1F2A40" : "#fff",
                "&:hover": { background: isDarkMode ? "#3d4a62" : "#f5f5f5" },
              }}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon
                sx={{ color: isDarkMode ? "#90caf9" : "#15294b" }}
              />
            </IconButton>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  background: isDarkMode ? "#1F2A40" : "#f5f6f7",
                  borderRadius: 80,
                  width: 80,
                  height: 80,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: 1,
                  borderColor: isDarkMode ? "#90caf9" : "#15294b",
                }}
              >
                <LocalMallOutlinedIcon
                  sx={{
                    color: isDarkMode ? "#90caf9" : "#15294b",
                    fontSize: 70,
                  }}
                />
              </Box>
              <Typography
                sx={{
                  color: isDarkMode ? "#e0e0e0" : "#15294b",
                  fontWeight: "bold",
                  textAlign: "center",
                  mt: 1,
                }}
                variant="h4"
              >
                {`Servicio #${infoCliente?.numero || trato?.contrato || "-"}`}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                mb: 2,
              }}
            >
              <ButtonBasic
                textButton="Descargar Reporte"
                iconStart={<BackupTableIcon />}
                onClick={() => onReporteServicioId()}
                variant="wk"
                color="nextWhite"
                sx={{ border: 1 }}
              />
            </Box>
            <Divider
              sx={{
                background: "#8993a4 !important",
                marginBottom: 1,
                width: "100%",
              }}
            />
            <TextInfoTicket
              titulo="Cuenta"
              descripcion={infoCliente?.cuenta || trato?.cuenta || "-"}
            />
            {infoCliente?.vip ||
              (trato?.vip && (
                <TextInfoTicket
                  titulo="Nivel VIP"
                  descripcion={infoCliente?.vip || trato?.vip || "-"}
                />
              ))}
            <TextInfoTicket
              titulo="Total Ticket"
              descripcion={tickets?.length}
            />
            {items?.length > 0 && (
              <TextInfoTicket
                titulo="Total Items"
                descripcion={items?.length - 1 || "0"}
              />
            )}
            <Divider
              sx={{
                background: "#8993a4 !important",
                marginBottom: 1,
                width: "100%",
              }}
            />
            {(permisos["saldo_pendiente_servicio"] ||
              permisos["saldo_pendiente_servicio_all"] ||
              permisos["saldo_pendiente_servicio_pyme"] ||
              permisos["saldo_pendiente_servicio_corpo"]) && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 1,
                  flexDirection: "column",
                }}
              >
                <ButtonBasic
                  textButton="Saldo Pendiente"
                  iconStart={<PaidOutlinedIcon />}
                  variant="wk"
                  color="nextWhite"
                  sx={{ border: 1 }}
                  onClick={() => onConsultarSaldo()}
                />
              </Box>
            )}
            {items?.length > 0 &&
              items[0]?.ubicacion?.latitud &&
              items[0]?.ubicacion?.longitud && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 1,
                    flexDirection: "column",
                  }}
                >
                  <ButtonBasic
                    textButton="Consultar Cobertura"
                    variant="wk"
                    color="nextWhite"
                    sx={{ border: 1 }}
                    onClick={() => onNuevaCobertura()}
                    isLoading={isLoading}
                  />
                </Box>
              )}
            {trato?.latitud && trato?.longitud && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 1,
                  flexDirection: "column",
                }}
              >
                <ButtonBasic
                  textButton="Consultar Cobertura"
                  variant="wk"
                  color="nextWhite"
                  sx={{ border: 1 }}
                  onClick={() => onNuevaCobertura()}
                  isLoading={isLoading}
                />
              </Box>
            )}
            {equipo && (
              <>
                <Typography
                  sx={{
                    color: isDarkMode ? "#e0e0e0" : "#15294b",
                    fontWeight: "bold",
                    marginLeft: 1,
                    marginTop: 1,
                    fontSize: 15,
                  }}
                  variant="h5"
                >
                  Equipo Instalado
                </Typography>
                <TextInfoTicket
                  titulo="Tecnologia"
                  descripcion={equipo?.tecServicio_tk?.toUpperCase() || "-"}
                />
                <TextInfoTicket
                  titulo="Nodo"
                  descripcion={equipo?.nodoName_tk || "-"}
                />
                <TextInfoTicket
                  titulo={equipo?.tecServicio_tk === "fibra" ? "Nap" : "Panel"}
                  descripcion={equipo?.panelName_tk || "-"}
                />
                {equipo?.tecServicio_tk === "fibra" && (
                  <TextInfoTicket
                    titulo="Puerto"
                    descripcion={equipo?.puertoNap_tk || "-"}
                  />
                )}
                <TextInfoTicket
                  titulo="Equipo"
                  descripcion={equipo?.equipo || "-"}
                />
                <TextInfoTicket titulo="Mac" descripcion={equipo?.mac || "-"} />
                <TextInfoTicket titulo="IP" descripcion={equipo?.wan || "-"} />
                <Divider
                  sx={{
                    background: "#8993a4 !important",
                    marginBottom: 1,
                    width: "100%",
                  }}
                />
              </>
            )}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  background: isDarkMode ? "#1a3a5c" : "#e6f0ff",
                  borderRadius: 50,
                  width: 35,
                  height: 35,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AccountCircleIcon
                  sx={{
                    color: isDarkMode ? "#90caf9" : "#15294b",
                    fontSize: 25,
                  }}
                />
              </Box>
              <Typography
                sx={{
                  color: isDarkMode ? "#e0e0e0" : "#15294b",
                  fontWeight: "bold",
                  textAlign: "center",
                  ml: 1,
                  "&:hover": {
                    cursor: "pointer",
                    color: isDarkMode ? "#90caf9" : "#0364ff",
                  },
                }}
                variant="h6"
                onClick={() =>
                  navigate(
                    `/contactos/${infoCliente?.cuenta || trato?.cuenta}/cuenta`,
                  )
                }
              >
                {infoCliente?.nombre || trato?.cliente}
              </Typography>
            </Box>
            {localBd?.autorizadoxPersonalId_t?.nombre_p &&
              localBd?.fechaAutorizado_t && (
                <>
                  <Divider
                    sx={{
                      background: isDarkMode ? "#3d4a62" : "#8993a4 !important",
                      marginBottom: 2,
                      width: "100%",
                    }}
                  />
                  <Typography
                    sx={{
                      color: isDarkMode ? "#e0e0e0" : "#15294b",
                      fontWeight: "bold",
                      textAlign: "left",
                      mb: 1,
                    }}
                    variant="h6"
                  >
                    Autorización
                  </Typography>
                  <TextInfoTicket
                    titulo="Autorizado Por:"
                    descripcion={localBd?.autorizadoxPersonalId_t?.nombre_p}
                  />
                  <TextInfoTicket
                    titulo="Fecha Autorizado:"
                    descripcion={FechaFunction.format(
                      new Date(localBd?.fechaAutorizado_t),
                      "dd/MM/yyyy HH:mm:ss",
                    )}
                  />
                </>
              )}
          </Card>
        </Grid>
        <Grid item xs={12} md={9}>
          <Card
            sx={{
              background: isDarkMode ? "#2d3a52" : "#fff !important",
              border: isDarkMode ? "1px solid #3d4a62" : "1px solid #e0e0e0",
              p: 2,
              borderRadius: 4,
            }}
          >
            <Box
              sx={{
                borderBottom: 1,
                borderColor: isDarkMode ? "#3d4a62" : "#6b788e",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                variant="scrollable"
                sx={{
                  "& .MuiTabs-indicator": {
                    background: isDarkMode ? "#90caf9" : "#0364ff",
                  },
                  "& .MuiButtonBase-root": {
                    color: isDarkMode ? "#b0bec5" : "#6b788e",
                    fontWeight: "bold",
                  },
                  "& .MuiButtonBase-root.Mui-selected": {
                    color: isDarkMode ? "#90caf9" : "#0364ff",
                  },
                }}
              >
                <Tab
                  label="Tickets"
                  {...a11yProps(0)}
                  sx={{ minWidth: "150px" }}
                />
                {items && items.length > 0 ? (
                  <Tab
                    label="Items"
                    {...a11yProps(1)}
                    sx={{ minWidth: "150px" }}
                  />
                ) : (
                  <Tab
                    label="Datos"
                    {...a11yProps(1)}
                    sx={{ minWidth: "150px" }}
                  />
                )}
                <Tab
                  label="Consultas"
                  {...a11yProps(2)}
                  sx={{ minWidth: "150px" }}
                />
                <Tab
                  label="Tareas"
                  {...a11yProps(3)}
                  sx={{ minWidth: "150px" }}
                />
                <Tab
                  label="Historico"
                  {...a11yProps(4)}
                  sx={{ minWidth: "150px" }}
                />
                <Tab
                  label="Ordenes de Trabajo"
                  {...a11yProps(5)}
                  sx={{ minWidth: "150px" }}
                />
                <Tab
                  label="Recordatorio"
                  {...a11yProps(6)}
                  sx={{ minWidth: "150px" }}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <TabCuentaTicket
                tickets={tickets}
                onGuardar={onGuardar}
                servicioNewTk={{
                  nombreCompleto: infoCliente?.nombre,
                  cuentaId: infoCliente?.cuenta,
                  cuentaContratoId: id,
                }}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              {extensiones && Object.keys(extensiones).length > 0 ? (
                Object.entries(extensiones).map(([keys, info]) => (
                  <Box
                    key={keys}
                    sx={{
                      border: 1,
                      borderColor: isDarkMode ? "#3d4a62" : "#dee2e6",
                      background: isDarkMode ? "#1F2A40" : "#f8f9fa",
                      borderRadius: "10px",
                      m: "5px",
                      p: 1,
                    }}
                  >
                    <CardCuentaProducto
                      item={info}
                      numero={keys}
                      onGuardar={actualizar}
                    />
                  </Box>
                ))
              ) : (
                <Card
                  sx={{
                    background: isDarkMode ? "#2d3a52" : "#fff",
                    mb: 3,
                    border: 1,
                    borderColor: isDarkMode ? "#3d4a62" : "#000",
                    borderRadius: 4,
                  }}
                >
                  <Box
                    sx={{
                      background:
                        trato?.estado_direntrega === "I"
                          ? isDarkMode
                            ? "#3c1f1f"
                            : "#fce7e7"
                          : isDarkMode
                            ? "#1a3a2a"
                            : "#e6f8f2",
                      p: 2,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12} md={10}>
                        <Typography
                          sx={{
                            color: isDarkMode ? "#e0e0e0" : "#15294b",
                            fontWeight: "bold",
                            mr: 2,
                          }}
                          variant="h5"
                        >{`${trato?.contrato} - ${trato?.nombre}`}</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={2}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ButtonBasic
                          textButton={
                            trato?.estado_direntrega === "I"
                              ? "DAR DE ALTA"
                              : "DAR DE BAJA"
                          }
                          variant="wk"
                          color={
                            trato?.estado_direntrega === "I"
                              ? "nextStep"
                              : "error"
                          }
                          sx={{
                            border: 1,
                            borderColor: "#fff",
                            minWidth: 150,
                            borderRadius: "10px !important",
                          }}
                          onClick={() =>
                            onOpenModalAltaBajaDirEntrega(trato?.contrato)
                          }
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Grid container spacing={1} p={1}>
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            color: isDarkMode ? "#e0e0e0" : "#000",
                            fontWeight: "bold",
                          }}
                          component="div"
                        >
                          Dirección:
                          <Box
                            sx={{
                              display: "inline",
                              fontWeight: "normal",
                              ml: 1,
                              color: isDarkMode ? "#b0bec5" : "inherit",
                            }}
                          >
                            {trato?.direccion_servicio || ""}
                          </Box>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            color: isDarkMode ? "#e0e0e0" : "#000",
                            fontWeight: "bold",
                          }}
                          component="div"
                        >
                          CCPP:
                          <Box
                            sx={{
                              display: "inline",
                              fontWeight: "normal",
                              ml: 1,
                              color: isDarkMode ? "#b0bec5" : "inherit",
                            }}
                          >{`${trato?.codpostal || ""} - ${trato?.localidad || ""}`}</Box>
                        </Typography>
                      </Box>
                    </Grid>
                    {trato?.latitud && (
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 2,
                          }}
                        >
                          <Typography
                            sx={{
                              color: isDarkMode ? "#e0e0e0" : "#000",
                              fontWeight: "bold",
                            }}
                            component="div"
                          >
                            Coordenadas:
                            <Box
                              sx={{
                                display: "inline",
                                fontWeight: "normal",
                                ml: 1,
                                color: isDarkMode ? "#b0bec5" : "inherit",
                              }}
                            >{`${trato?.latitud}, ${trato?.longitud}`}</Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            color: isDarkMode ? "#e0e0e0" : "#000",
                            fontWeight: "bold",
                          }}
                          component="div"
                        >
                          Segmento:
                          <Box
                            sx={{
                              display: "inline",
                              fontWeight: "normal",
                              ml: 1,
                              color: isDarkMode ? "#b0bec5" : "inherit",
                            }}
                          >
                            {trato?.segmento || ""}
                          </Box>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            color: isDarkMode ? "#e0e0e0" : "#000",
                            fontWeight: "bold",
                          }}
                          component="div"
                        >
                          Estado:
                          <Box
                            sx={{
                              display: "inline",
                              fontWeight: "normal",
                              ml: 1,
                              color: isDarkMode ? "#b0bec5" : "inherit",
                            }}
                          >
                            {trato?.estado_direntrega === "A"
                              ? "Activo"
                              : "Inactivo" || ""}
                          </Box>
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              )}
            </TabPanel>
            <TabPanel value={value} index={2}>
              <TabCuentaConsultas
                consultas={consultas}
                actualizar={actualizar}
                actualizarRecordatorios={actualizarRecordatorios}
              />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <TabCuentaTareas tareas={tareas} traerTareas={actualizarTareas} />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <TabCuentaHistorico
                historico={logs}
                infoCliente={{
                  cuentaId: infoCliente?.cuenta || trato?.cuenta,
                  hiddenSelect: true,
                  servicioId: id,
                }}
                onGuardar={actualizarHistorico}
              />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <CardOTZTask otsServicio={otsServicio} />
            </TabPanel>
            <TabPanel value={value} index={6}>
              <TabCuentaRecodatorios
                recordatoriosAll={recordatorios}
                cuenta={infoCliente?.cuenta}
                servicioId={infoCliente?.numero}
                nombreCompleto={infoCliente?.cliente || infoCliente?.nombre}
                onGuardar={actualizarRecordatorios}
              />
            </TabPanel>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServicioCuentaVerScreen;
